export default "__VITE_ASSET__8ea50aef__"